var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gallery-list-component',{attrs:{"memberKey":_vm.memberKey,"gallery-type":'creatorGallery',"defaultFilter":_vm.defaultFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }